<template>
  <el-drawer
    v-model="showProxy"
    class="modal-container"
    direction="rtl"
    size="60%"
    :with-header="true"
    :append-to-body="true"
    :modal-append-to-body="true"
    @close="handleClose()"
  >
    <!-- >>>>>> 弹窗头部 <<<<<< -->
    <template #header>
      <div class="header-container">
        <div class="icon-container"></div>
        <span class="title-text">{{ $str.getKey('收益管理/操作历史') }}</span>
      </div>
    </template>

    <!-- >>>>>> 弹窗内容 <<<<<< -->
    <template #default>
      <div class="content-container">
        <HistoryLogList></HistoryLogList>
      </div>
    </template>

    <!-- >>>>>> 弹窗底部 <<<<<< -->
    <template #footer v-if="false">
      <div class="footer-container">
        <el-button @click="handleClose()" :disabled="isConfirming">{{ $str.getKey('收益管理/取消') }}</el-button>
        <el-button type="primary" @click="onConfirm" class="confirm-btn" :disabled="isConfirming">{{ $str.getKey('收益管理/确定') }}</el-button>
      </div>
    </template>
  </el-drawer>
</template>
<script setup>
import { defineEmits, defineOptions, defineProps, onMounted, reactive, ref, nextTick, watch, computed, watchEffect } from "vue";
import { useVModel } from "@vueuse/core";
import { ElMessageBox } from 'element-plus'
import dayjs from 'dayjs';
import { useAppStore } from "@/store/modules/app";
import { cloneDeep } from "@/utils"
import HistoryLogList from "./historyLogList.vue"

const $str = window.$str;

const stationId = computed(() => {
  return useAppStore().stationId
})

/** 设置组件配置项 */
defineOptions({
  name: "HistoryModal"
});

/** 接收父组件信息 */
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    require: true,
  },
});

const emit = defineEmits(['update:show', 'onClose']);
const showProxy = useVModel(props, "show", emit);
const isConfirming = ref(false); // 防抖【连续多次点击提交按钮】




// 表单信息
const formData = reactive({
  
})

// 初始化面板
initPanel();









/** ====== [业务：功能方法] =================================================================== */


/** 关闭面板 */
function handleClose(needRefresh = false) {
  emit("onClose", props.type, needRefresh);
}


/** 提交表单 */
async function onConfirm() {}






/** ====== [辅助：功能方法] =================================================================== */
/** 初始化：面板信息 */
function initPanel() {

}




</script>

<style lang="scss" scoped>
.modal-container {
  :deep(.el-drawer__header) {
    margin-bottom: 0;
    padding: 14px 16px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  }

  :deep(.el-drawer__body) {
    padding: 0;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
  }

  .header-container {
    & {
      height: auto;
      padding-left: 0;
      display: flex;
      align-items: center;
    }

    .icon-container {
      display: none;
    }

    .title-text {
      font-family: PingFang-SC, PingFang-SC;
      font-size: 16px;
      font-weight: 600;
      color: rgba(46, 46, 46, 0.88);
      text-align: left;
      letter-spacing: 0;
    }
  }

  .content-container {
    & {
      width: 100%;
      box-sizing: border-box;
      padding: 14px 16px 16px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      gap: 10px;

    }

  }

}
</style>